/**
 * Cash Register Report Calculations
 * Shared utility functions for calculating cash register summary data
 */

export function calculateAllOrderSummary(data, allPaymentMethods, allItemCategories, allTables, settings, allGlobalDiscounts) {
  try {
    const order_paid = data?.filter((order) => {
      // return ((order.status === "paid" && !order?.is_credit) || (order?.is_credit && order?.is_paid_off))
      return order.status === "paid";
    });
    const order_void = data?.filter((order) => order.status === "canceled");

    const sales_order_code = data?.map((order) => order?.code);

    // Initialize arrays for different breakdowns
    let sales_by_type = [];
    let sales_by_category_item = [];
    let sales_by_table = [];
    let sales_by_payment_type = [];
    let sales_by_global_discount = [
      {
        type: 'Global Discount',
        qty: 0,
        revenue_item: 0,
        item_discount: 0,
        bill_discount: 0,
        revenue_sales: 0,
        revenue_net_sales: 0,
        sales_quantity: 0,
      },
      {
        type: 'No Promo',
        qty: 0,
        revenue_item: 0,
        item_discount: 0,
        bill_discount: 0,
        revenue_sales: 0,
        revenue_net_sales: 0,
        sales_quantity: 0,
      }
    ];

    let total_sales_by_type = 0;
    let total_sales_by_category_item = 0;
    let total_sales_by_global_discount = 0;
    let total_sales_by_table = 0;
    let total_sales_by_payment_type = 0;
    let revenue_complimentary = 0;
    let pax = 0;

    // Process each paid order
    let revenue_item = 0;
    let item_discount = 0;
    let total_item = 0;
    let revenue_sales = 0;
    let bill_discount = 0;
    let revenue_net_sales = 0;
    let total_service_charge = 0;
    let total_tax = 0;
    let gross_sales = 0;
    let revenue_sales_without_service_charge = 0;
    let total_qty_bill = 0;
    let revenue_sales_without_tax = 0;
    let total_qty_cancel_item = 0;
    let total_revenue_cancel_item = 0;
    let total_item_complimentary = 0;

    order_paid.forEach((order) => {
      let items = [];
      order?.menus?.forEach((item) => {
        const complimentary = item?.complimentary ? true : false;
        let isExist = items?.findIndex((i) => {
          const icompliment = i?.complimentary ? true : false;
          return i?.item_id == item?.item_id && icompliment === complimentary && i?.discount_applied == item?.discount_applied && i?.tax_applied == item?.tax_applied && i?.service_charge_applied == item?.service_charge_applied && i?.discount_price == item?.discount_price && i?.price == item?.price;
        });
        const isExistGlobalDiscount = allGlobalDiscounts?.find((i) => i?.id == order?.global_discount_id)?.amount;
        const service_charge_applied = order?.menus?.find((i) => i?.item_id == item?.item_id && i?.status === "pending")?.service_charge_applied;
        const tax_applied = order?.menus?.find((i) => i?.item_id == item?.item_id && i?.status === "pending")?.tax_applied;
        const discount_applied = order?.menus?.find((i) => i?.item_id == item?.item_id && i?.status === "pending")?.discount_applied;

        const discount_price = parseFloat(item?.discount_price) * Number(item?.qty);
        const revenue_item = parseFloat(item?.price) * Number(item?.qty);
        const revenue_sales = (parseFloat(item?.price) - parseFloat(item?.discount_price)) * Number(item?.qty);
        const bill_discount = isExistGlobalDiscount && discount_applied ? (parseFloat(isExistGlobalDiscount) * parseFloat(revenue_sales) / 100) : 0;
        const tax = tax_applied ? parseFloat(revenue_sales) * Number(settings.tax) / 100 : 0;
        const service_charge = service_charge_applied ? (parseFloat(revenue_sales) - parseFloat(bill_discount)) * Number(settings.service_charge) / 100 : 0;
        const revenue_net_sales = revenue_sales + tax + service_charge - bill_discount;

        if (isExist == -1) {
          items.push({
            ...item,
            quantity: (item.status == "canceled" ? -1 : 1) * Number(item.qty),
            subtotal: (item.status == "canceled" ? -1 : 1) * parseFloat(item.price) * Number(item.qty),
            total_discount: (item.status == "canceled" ? -1 : 1) * discount_price,
            total_revenue: (item.status == "canceled" ? -1 : 1) * revenue_item,
            total_revenue_sales: (item.status == "canceled" ? -1 : 1) * parseFloat(revenue_sales),
            total_bill_discount: (item.status == "canceled" ? -1 : 1) * parseFloat(bill_discount),
            total_tax: (item.status == "canceled" ? -1 : 1) * parseFloat(tax),
            total_service_charge: (item.status == "canceled" ? -1 : 1) * parseFloat(service_charge),
            total_revenue_net_sales: (item.status == "canceled" ? -1 : 1) * parseFloat(revenue_net_sales),
            complimentary,
            status: "pending"
          });
        } else {
          items[isExist].quantity += (item.status == "canceled" ? -1 : 1) * Number(item.qty);
          items[isExist].subtotal += (item.status == "canceled" ? -1 : 1) * parseFloat(item.price) * Number(item.qty);
          items[isExist].total_discount += (item.status == "canceled" ? -1 : 1) * discount_price;
          items[isExist].total_revenue += (item.status == "canceled" ? -1 : 1) * revenue_item;
          items[isExist].total_revenue_sales += (item.status == "canceled" ? -1 : 1) * parseFloat(revenue_sales);
          items[isExist].total_bill_discount += (item.status == "canceled" ? -1 : 1) * parseFloat(bill_discount);
          items[isExist].total_tax += (item.status == "canceled" ? -1 : 1) * parseFloat(tax);
          items[isExist].total_service_charge += (item.status == "canceled" ? -1 : 1) * parseFloat(service_charge);
          items[isExist].total_revenue_net_sales += (item.status == "canceled" ? -1 : 1) * parseFloat(revenue_net_sales);
        }
      });

      const isExist = sales_by_type.findIndex((item) => item?.type === order?.order_type);
      const isExistTable = sales_by_table.findIndex((item) => item?.table_id === order?.table_id);

      const revenueItem = items?.filter((item) => !item?.complimentary)?.reduce((sum, item) => {
        return sum + parseFloat(item?.total_revenue || 0)
      }, 0);
      const itemDiscount = items?.filter((item) => !item?.complimentary)?.reduce((sum, item) => {
        return sum + parseFloat(item?.total_discount || 0)
      }, 0);
      const totalItem = items?.filter((item) => !item?.complimentary)?.reduce((sum, item) => {
        return sum + parseFloat(item?.quantity || 0)
      }, 0);
      const revenueSales = items?.filter((item) => !item?.complimentary)?.reduce((sum, item) => {
        return sum + parseFloat(item?.total_revenue_sales || 0)
      }, 0);
      const billDiscount = items?.filter((item) => !item?.complimentary)?.reduce((sum, item) => {
        return sum + parseFloat(item?.total_bill_discount || 0)
      }, 0);
      const revenueNetSales = items?.filter((item) => !item?.complimentary)?.reduce((sum, item) => {
        return sum + parseFloat(item?.total_revenue_net_sales || 0)
      }, 0);
      const totalServiceCharge = items?.filter((item) => !item?.complimentary)?.reduce((sum, item) => {
        return sum + parseFloat(item?.total_service_charge || 0)
      }, 0);
      const totalTax = items?.filter((item) => !item?.complimentary)?.reduce((sum, item) => {
        return sum + parseFloat(item?.total_tax || 0)
      }, 0);

      // Basic calculations
      revenue_item += revenueItem;
      item_discount += itemDiscount;
      total_item += totalItem;

      revenue_sales += revenueSales;
      bill_discount += billDiscount;
      revenue_net_sales += revenueNetSales;
      total_service_charge += totalServiceCharge;
      total_tax += totalTax;
      revenue_sales_without_service_charge += items?.filter((item) => !item?.complimentary && item?.total_service_charge == 0)?.reduce((sum, item) => sum + parseFloat(item?.total_revenue_sales || 0), 0);
      total_qty_bill = order_paid?.length;
      revenue_sales_without_tax += items?.filter((item) => !item?.complimentary && item?.total_tax == 0)?.reduce((sum, item) => sum + parseFloat(item?.total_revenue_net_sales || 0), 0);

      total_qty_cancel_item += order.menus.reduce((sum, item) => {
        return sum + (item?.status === "canceled" ? Number(item?.qty || 0) : 0);
      }, 0);

      total_revenue_cancel_item += order.menus.reduce((sum, item) => {
        return sum + (item?.status === "canceled" ? (Number(item?.price || 0) - Number(item?.discount_price || 0)) * Number(item?.qty || 0) : 0);
      }, 0);

      const revenue_complimentary_item = items?.filter((item) => item?.complimentary)?.reduce((sum, item) => {
        return sum + parseFloat(item?.total_revenue || 0)
      }, 0);

      pax += Number(order?.pax || 0);

      // Sales by type
      if (isExist !== -1) {
        sales_by_type[isExist].qty += total_item;
        sales_by_type[isExist].revenue_item += revenueItem;
        sales_by_type[isExist].item_discount += itemDiscount;
        sales_by_type[isExist].bill_discount += billDiscount;
        sales_by_type[isExist].revenue_sales += revenueSales;
        sales_by_type[isExist].revenue_net_sales += revenueSales - billDiscount;
        sales_by_type[isExist].gross_sales += revenueNetSales;
      } else {
        sales_by_type.push({
          type: order?.order_type,
          qty: total_item,
          revenue_item: revenueItem,
          item_discount: itemDiscount,
          bill_discount: billDiscount,
          revenue_sales: revenueSales,
          revenue_net_sales: revenueSales - billDiscount,
          gross_sales: revenueNetSales,
        });
      }

      // Sales by table
      if (isExistTable !== -1) {
        sales_by_table[isExistTable].qty += total_item;
        sales_by_table[isExistTable].revenue_item += revenueItem;
        sales_by_table[isExistTable].item_discount += itemDiscount;
        sales_by_table[isExistTable].bill_discount += billDiscount;
        sales_by_table[isExistTable].revenue_sales += revenueSales;
        sales_by_table[isExistTable].revenue_net_sales += revenueSales - billDiscount;
        sales_by_table[isExistTable].pax += Number(order?.pax || 0);
      } else {
        sales_by_table.push({
          table_id: order?.table_id,
          table_name: allTables.find((table) => table?.id === order?.table_id)?.name,
          qty: total_item,
          revenue_item: revenueItem,
          item_discount: itemDiscount,
          bill_discount: billDiscount,
          revenue_sales: revenueSales,
          revenue_net_sales: revenueSales - billDiscount,
          pax: Number(order?.pax || 0),
        });
      }

      revenue_complimentary += revenue_complimentary_item;
      total_item_complimentary += items?.filter((item) => item?.complimentary)?.reduce((sum, item) => {
        return sum + parseFloat(item?.quantity || 0)
      }, 0);

      const paymentMethod = allPaymentMethods?.find((item) => item?.id == order?.payment_method_id);
      const paymentMethodeName = paymentMethod?.name.toLowerCase().includes("hutang") ? `${order?.is_paid_off ? "Hutang Terbayar" : "Hutang Belum Lunas"}` : paymentMethod?.name;
      const isExistPaymentType = sales_by_payment_type.findIndex((item) => item?.payment_method_name === paymentMethodeName);

      // Sales by payment type
      if (isExistPaymentType !== -1) {
        sales_by_payment_type[isExistPaymentType].qty += total_item;
        sales_by_payment_type[isExistPaymentType].revenue_item += revenueItem;
        sales_by_payment_type[isExistPaymentType].item_discount += itemDiscount;
        sales_by_payment_type[isExistPaymentType].bill_discount += billDiscount;
        sales_by_payment_type[isExistPaymentType].revenue_sales += revenueSales;
        sales_by_payment_type[isExistPaymentType].revenue_net_sales += revenueSales - billDiscount;
        sales_by_payment_type[isExistPaymentType].payment_amount += parseFloat(order?.payment_amount || 0);
        sales_by_payment_type[isExistPaymentType].payment_change += parseFloat(order?.payment_change || 0);
        sales_by_payment_type[isExistPaymentType].payment_balance += paymentMethodeName && !paymentMethodeName.includes("Hutang Belum Lunas") ? parseFloat(order?.payment_amount || 0) - parseFloat(order?.payment_change || 0) : 0;
        sales_by_payment_type[isExistPaymentType].sales_quantity += 1;
      } else {
        sales_by_payment_type.push({
          payment_type: order?.payment_method_id,
          payment_method_name: paymentMethodeName,
          qty: total_item,
          revenue_item: revenueItem,
          item_discount: itemDiscount,
          bill_discount: billDiscount,
          revenue_sales: revenueSales,
          revenue_net_sales: revenueSales - billDiscount,
          payment_amount: parseFloat(order?.payment_amount || 0),
          payment_change: parseFloat(order?.payment_change || 0),
          payment_balance: paymentMethodeName && !paymentMethodeName.includes("Hutang Belum Lunas") ? parseFloat(order?.payment_amount || 0) - parseFloat(order?.payment_change || 0) : 0,
          sales_quantity: 1,
        });
      }

      // Sales by category
      items?.filter((menu) => !menu?.complimentary)?.forEach((menu) => {
        const isExistCategoryItem = sales_by_category_item.findIndex((item) => item?.category_item_id === menu?.items?.item_category_id);

        if (isExistCategoryItem !== -1) {
          sales_by_category_item[isExistCategoryItem].qty += menu?.quantity;
          sales_by_category_item[isExistCategoryItem].revenue_item += menu?.total_revenue;
          sales_by_category_item[isExistCategoryItem].item_discount += menu?.total_discount;
          sales_by_category_item[isExistCategoryItem].bill_discount += menu?.total_bill_discount;
          sales_by_category_item[isExistCategoryItem].revenue_sales += menu?.total_revenue_sales;
          sales_by_category_item[isExistCategoryItem].revenue_net_sales += menu?.total_revenue_sales - menu?.total_bill_discount;
        } else {
          sales_by_category_item.push({
            category_name: allItemCategories.find((item) => item?.id === menu?.items?.item_category_id)?.name,
            category_item_id: menu?.items?.item_category_id,
            qty: menu?.quantity,
            revenue_item: menu?.total_revenue,
            item_discount: menu?.total_discount,
            bill_discount: menu?.total_bill_discount,
            revenue_sales: menu?.total_revenue_sales,
            revenue_net_sales: menu?.total_revenue_sales - menu?.total_bill_discount,
          });
        }
      });

      // Sales by global discount
      items?.filter((menu) => !menu?.complimentary)?.forEach((menu) => {

        if (menu?.total_bill_discount > 0) {
          sales_by_global_discount[0].qty += menu?.quantity;
          sales_by_global_discount[0].revenue_item += menu?.total_revenue;
          sales_by_global_discount[0].item_discount += menu?.total_discount;
          sales_by_global_discount[0].bill_discount += menu?.total_bill_discount;
          sales_by_global_discount[0].revenue_sales += menu?.total_revenue_sales;
          sales_by_global_discount[0].revenue_net_sales += menu?.total_revenue_sales - menu?.total_bill_discount;
          sales_by_global_discount[0].sales_quantity += 1;
        } else {
          sales_by_global_discount[1].qty += menu?.quantity;
          sales_by_global_discount[1].revenue_item += menu?.total_revenue;
          sales_by_global_discount[1].item_discount += menu?.total_discount;
          sales_by_global_discount[1].bill_discount += menu?.total_bill_discount;
          sales_by_global_discount[1].revenue_sales += menu?.total_revenue_sales;
          sales_by_global_discount[1].revenue_net_sales += menu?.total_revenue_sales - menu?.total_bill_discount;
          sales_by_global_discount[1].sales_quantity += 1;
        }
      });

      // Update totals
      total_sales_by_type += parseFloat(revenueSales || 0) - parseFloat(billDiscount || 0);
      total_sales_by_category_item += parseFloat(revenueSales || 0) - parseFloat(billDiscount || 0);
      total_sales_by_global_discount += parseFloat(revenueSales || 0) - parseFloat(billDiscount || 0);
      total_sales_by_table += parseFloat(revenueSales || 0) - parseFloat(billDiscount || 0);
      total_sales_by_payment_type += parseFloat(revenueNetSales || 0) - parseFloat(billDiscount || 0);
    });

    return {
      data: { ...data },
      revenue_item: revenue_item,
      item_discount: item_discount,
      revenue_sales: revenue_sales,
      bill_discount: bill_discount,
      total_sales: revenue_sales - bill_discount,
      revenue_net_sales: revenue_net_sales,
      total_service_charge: total_service_charge,
      total_tax: total_tax,
      total_item: total_item,
      gross_sales: gross_sales,
      total_qty_bill: total_qty_bill,
      total_bill: order_paid?.length,
      revenue_sales_per_bill: revenue_net_sales / order_paid?.length,
      revenue_sales_without_service_charge: revenue_sales_without_service_charge,
      revenue_sales_without_tax: revenue_sales_without_tax,
      total_qty_void_sales: order_void?.length,
      revenue_void_sales: order_void?.reduce((sum, order) => {
        return sum + order.menus.reduce((sum, item) => {
          return sum + parseFloat(item?.price || 0)
        }, 0);
      }, 0),
      total_qty_cancel_item: total_qty_cancel_item,
      revenue_cancel_item: total_revenue_cancel_item,
      sales_order_code: sales_order_code,
      sales_by_type: sales_by_type,
      sales_by_category_item: sales_by_category_item,
      sales_by_global_discount: sales_by_global_discount,
      sales_by_table: sales_by_table,
      sales_by_payment_type: [...sales_by_payment_type, { id: 999, payment_method_name: "Complimentary", revenue_net_sales: revenue_complimentary, total_item: total_item_complimentary }],
      total_sales_by_type: total_sales_by_type,
      total_sales_by_category_item: total_sales_by_category_item,
      total_sales_by_global_discount: total_sales_by_global_discount,
      total_sales_by_table: total_sales_by_table,
      total_sales_by_payment_type: total_sales_by_payment_type,
      total_pax_by_floor: pax,
    };
  } catch (error) {
    console.error('Cash register calculation error:', error);
    throw error;
  }
}
